import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CaseEnvChangeRedirectService {
    public getCaseEnvChangeRedirectUrl(caseEnvChangeRedirectUrl: string, newCaseName: string, newEnvironmentName: string): string[] {
        return caseEnvChangeRedirectUrl
            .split('/')
            .map(x => x.replace(':clientName', newCaseName).replace(':environment', newEnvironmentName))
            .filter(x => x);
    }
}
